'use client';

import { eventNames, useCoreEvents } from '@carvana/core-events';
import { isSuccess } from '@carvana/merch-result';
import { usePathname, useSearchParams } from 'next/navigation';
import { refreshAfterSoftpullAction } from '~/app/(carvana-layout)/financing-rsc/actions';
import { DATADOG_EVENTS } from '~/constants/flp/datadogEvents';
import { reportActionFailure } from '~/utilities/flp/reportClientError';

const OPEN_SOFTPULL_QUERY_PARAM = 'openSoftpullModal';

/**
 * Fork of `~/hooks/flp/useSoftpullModalEvents` that calls
 * `refreshAfterSoftpullAction` instead of `refreshTerms()`.
 * Never auto-opens the modal — like control, only the marketing page does.
 */
export default function useSoftpullModalEvents() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const clearSoftpullQueryParam = () => {
    const params = new URLSearchParams(searchParams?.toString());

    if (params.has(OPEN_SOFTPULL_QUERY_PARAM)) {
      params.delete(OPEN_SOFTPULL_QUERY_PARAM);

      const queryParams = params.toString();
      const newUrl = queryParams ? `${pathname}?${queryParams}` : pathname;

      // Must use native window history to prevent RSC fetching loop caused by reverse proxy
      window.history.replaceState({ scroll: false }, '', newUrl);
    }
  };

  useCoreEvents(eventNames.softpullModal.success, async () => {
    try {
      const result = await refreshAfterSoftpullAction();

      if (!isSuccess(result)) {
        reportActionFailure(
          DATADOG_EVENTS.API.REFRESH_AFTER_SOFTPULL_API_ERROR,
          'Refresh After Softpull',
          result.errorMessage
        );
      }
    } catch {
      reportActionFailure(
        DATADOG_EVENTS.API.REFRESH_AFTER_SOFTPULL_API_ERROR,
        'Refresh After Softpull'
      );
    }
  });

  useCoreEvents(eventNames.softpullModal.close, () => {
    clearSoftpullQueryParam();
  });
}
